import type { CSSProperties } from 'react';
import { useI18nContext } from '@/i18n/i18n-react';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

export function CampaignAnalyticsEmptyState({
  className,
  style,
}: {
  className?: string;
  style?: CSSProperties;
}) {
  const { LL } = useI18nContext();

  return (
    <Card
      className={cn('w-full border-0 bg-secondary', className)}
      style={style}
    >
      <CardContent className="flex min-h-[10.5rem] min-[480px]:min-h-[18.5rem] lg:min-h-[10.5rem] items-center justify-center p-8 text-center">
        <p className="text-sm text-secondary-foreground">
          {LL.campaignDetails.analyticsEmptyState()}
        </p>
      </CardContent>
    </Card>
  );
}
